/**
 * Lib.Common: v-label-done directive
 *
 * Event handler for v-label `done` action button.
 */


function bind(el, binding, vnode) {
    el._ldone = binding.value;
}


function unbind(el) {
    delete el._ldone;
}


export default {
    name: 'label-done',
    directive: {
        bind,
        unbind,
        update: bind
    }
};
